import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import GenshinDialog from "common/components/GenshinDialog";
import React from "react";
import { useTranslation } from "react-i18next";

type RequestDialogProps = {
  open: boolean;
  title: string;
  message: React.ReactNode;
  onAccept?: () => void;
  onDecline?: () => void;
};

const RequestDialog = ({
  open,
  title,
  message,
  onAccept,
  onDecline,
}: RequestDialogProps) => {
  const { t } = useTranslation();

  return (
    <GenshinDialog
      open={open}
      onClose={() => {}}
      disableEscapeKeyDown
      aria-labelledby="request-dialog-title"
    >
      <DialogTitle id="request-dialog-title">{title}</DialogTitle>
      <DialogContent>{message}</DialogContent>
      {(onAccept || onDecline) && (
        <DialogActions>
          {onDecline && (
            <Button color="error" onClick={onDecline}>
              {t("Refuser")}
            </Button>
          )}
          {onAccept && (
            <Button color="success" onClick={onAccept}>
              {t("Accepter")}
            </Button>
          )}
        </DialogActions>
      )}
    </GenshinDialog>
  );
};

export default RequestDialog;
